import BaseServiceHttp from '../baseService'
class DashboardsPostagem extends BaseServiceHttp {
  constructor(id) {
    const resource = 'dashboards/emprestimos'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new DashboardsPostagem(id)
